import { B2bComponent } from '../b2b.component';
import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { SharedService } from 'src/app/shared.service';
import { ManagementServiceService } from 'src/app/management-service.service';
import { TranslateService } from '@ngx-translate/core';
import {ActivatedRoute, Router} from "@angular/router";
import { MatRadioChange } from '@angular/material/radio';
import { MatBottomSheet, MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import {MatSliderModule} from '@angular/material/slider';
import { Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import {CdkTextareaAutosize} from '@angular/cdk/text-field';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
import {B2BService} from 'src/app/b2-b.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {

  constructor(public parent: B2bComponent, private B2BService:B2BService, private managementService:ManagementServiceService, private service:SharedService, private cookieService: CookieService, public translate: TranslateService, private router:Router, private _bottomSheet: MatBottomSheet,  private route: ActivatedRoute) { 
    translate.addLangs(['en', 'ro']);
    translate.setDefaultLang('en');

    const browserLang = this.parent.getLanguage();
    translate.use(browserLang.match(/en|ro/) ? browserLang : 'en');

    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
  }

  Password:string;
  NewPassword:string;
  ConfirmNewPassword:string;

  hide:boolean;
  hideNewPass:boolean;
  hideConfirmNewPass:boolean;

  B2BPartner:any;

  Currencies:any[];
  PrefferedCurrency:any;

  ngOnInit(): void {
    this.hide = true;
    this.hideNewPass = true;
    this.hideConfirmNewPass = true;
    this.GetB2BUserConnectedPartner(this.parent.User);
    this.GetOrdersMasterData();
    this.GetUserB2BSettings();
  }

  selectText(event: Event): void {
    const target = event.target as HTMLTextAreaElement;
    target.select();
  }
  
  GetOrdersMasterData(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
    };
  
    this.B2BService.GetOrdersMasterData(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Currencies = JSON.parse(JSON.stringify(response["Currencies"]));

        if(this.parent.User.PrefferedCurrency == null){
          this.parent.User.PrefferedCurrency = this.Currencies.filter(x => x.IsInternationalCurrency == true)[0];
          localStorage.setItem('User', JSON.stringify(this.parent.User));
        }
      }
    });
  }

  GetB2BUserConnectedPartner(user:any){

    var request = {
      User:user,
      Language:this.parent.getLanguage(),
    };
  
    this.B2BService.GetB2BUserConnectedPartner(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.B2BPartner = response["Partner"];
      }
    });
  }

  UpdateUser(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage()
    };

    this.parent.loading = true;

    this.service.UpdateUser(request).subscribe(response => {
   
      if(response["Status"] != 1){
        
      }
      else if(response["Status"] == 1){

        var previousUser = JSON.parse(localStorage.getItem("User"));
        localStorage.setItem('User', JSON.stringify(this.parent.User));

        if(previousUser.B2BSettings.PrefferedCurrency.ID != this.parent.User.B2BSettings.PrefferedCurrency.ID)
        {
          this.parent.ClearGrid();
        }
      }
   
      this.parent.loading = false;
    });
  }

  ChangeUserPassword(){

    var request = {
      User:this.parent.User,
      Password:this.Password,
      NewPassword:this.NewPassword,
      ConfirmNewPassword:this.ConfirmNewPassword,
      Language:this.parent.getLanguage()
    };

    this.parent.loading = true;

    this.service.ChangeUserPassword(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
   
      this.parent.loading = false;
    });
  }

  ShowMyData:boolean = true;
  ShowBilling:boolean = false;
  ShowShipping:boolean = false;
  LoadShippingAddresses:boolean = false;
  CurrentShippingAddress:any;
  CurrentShippingAddressChangeRequest:any;
  ShippingAddressChangeRequests:any[];

  AddPartnerShippingAddressChangeRequest(address:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ShippingAddress:address
    };
  
    this.B2BService.AddPartnerShippingAddressChangeRequest(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.CurrentShippingAddressChangeRequest = response["ShippingAddressChangeRequest"];
      }
    });
  }

  GetShippingAddresses(){
    this.ShowShipping = !this.ShowShipping;

    if(this.ShowShipping == true){
      this.GetPartnerShippingAddresses(this.B2BPartner.ID);
    }
  }

  GetPartnerShippingAddresses(PartnerID:string){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      PartnerID:PartnerID
    };

    this.LoadShippingAddresses = true;
    this.service.GetPartnerShippingAddresses(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.B2BPartner.ShippingAddresses = response["ShippingAddresses"];
        this.CurrentShippingAddress = this.B2BPartner.ShippingAddresses[0];
        this.GetPartnerShippingAddressChangeRequest(this.B2BPartner.ID);
      }
   
      this.LoadShippingAddresses = false;
    });
  }

  GetPartnerShippingAddressChangeRequest(PartnerID:string){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      PartnerID:PartnerID
    };

    this.LoadShippingAddresses = true;
    this.B2BService.GetPartnerShippingAddressChangeRequest(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.ShippingAddressChangeRequests = response["ShippingAddressChangeRequests"];
        this.FindCurrentChangeRequest();
      }
   
      this.LoadShippingAddresses = false;
    });
  }

  GetUserB2BSettings(){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
    };

    this.parent.loading = true;
    this.service.GetUserB2BSettings(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.parent.User.B2BSettings = JSON.parse(JSON.stringify(response["B2BSettings"]));
      }
   
      this.parent.loading = false;
    });
  }

  FindCurrentChangeRequest(){
    this.CurrentShippingAddressChangeRequest = null;

    if(this.ShippingAddressChangeRequests != null){
      for(var i=0; i < this.ShippingAddressChangeRequests.length; i++){
        if(this.ShippingAddressChangeRequests[i].RequestingShippingAddressID == this.CurrentShippingAddress.ID){
          this.CurrentShippingAddressChangeRequest = this.ShippingAddressChangeRequests[i];
        }
      }
    }
  }

}
